import { render } from "./MonoPhotoSelector.vue?vue&type=template&id=7c1ce10c&scoped=true"
import script from "./MonoPhotoSelector.vue?vue&type=script&lang=js"
export * from "./MonoPhotoSelector.vue?vue&type=script&lang=js"

import "./MonoPhotoSelector.vue?vue&type=style&index=0&id=7c1ce10c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c1ce10c"]])

export default __exports__